/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './physical-cards.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../navbar/navbar.component.ngfactory';
import * as i3 from '../../../../../../../app/components/navbar/navbar.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../../../app/shared/_services/login.service';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../../../../../../app/shared/_services/hca-user-management.service';
import * as i8 from '../../../../../../../app/shared/_services/util.service';
import * as i9 from '../../../../../../../app/components/admin/hca-admin/physical-cards/physical-cards/physical-cards.component';
const styles_PhysicalCardsComponent:any[] = [i0.styles];
export const RenderType_PhysicalCardsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PhysicalCardsComponent,data:{}});
export function View_PhysicalCardsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarComponent_0,
      i2.RenderType_NavbarComponent)),i1.ɵdid(1,114688,(null as any),0,i3.NavbarComponent,
      [i4.Router,i5.LoginService,i6.TranslateService,i7.HcaUserManagementService,i8.UtilService],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(3,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_PhysicalCardsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-physical-cards',
      ([] as any[]),(null as any),(null as any),(null as any),View_PhysicalCardsComponent_0,
      RenderType_PhysicalCardsComponent)),i1.ɵdid(1,114688,(null as any),0,i9.PhysicalCardsComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PhysicalCardsComponentNgFactory:i1.ComponentFactory<i9.PhysicalCardsComponent> = i1.ɵccf('app-physical-cards',
    i9.PhysicalCardsComponent,View_PhysicalCardsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL3BoeXNpY2FsLWNhcmRzL3BoeXNpY2FsLWNhcmRzL3BoeXNpY2FsLWNhcmRzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9waHlzaWNhbC1jYXJkcy9waHlzaWNhbC1jYXJkcy9waHlzaWNhbC1jYXJkcy5jb21wb25lbnQudHMiLCJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9waHlzaWNhbC1jYXJkcy9waHlzaWNhbC1jYXJkcy9waHlzaWNhbC1jYXJkcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL3BoeXNpY2FsLWNhcmRzL3BoeXNpY2FsLWNhcmRzL3BoeXNpY2FsLWNhcmRzLmNvbXBvbmVudC50cy5QaHlzaWNhbENhcmRzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1uYXZiYXI+PC9hcHAtbmF2YmFyPlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiIsIjxhcHAtcGh5c2ljYWwtY2FyZHM+PC9hcHAtcGh5c2ljYWwtY2FyZHM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtNQUFBLDZCQUF5QiwwQ0FDekI7YUFBQTtVQUFBO2FBQUE7MERBQUE7VUFBQTtJQURBO0lBQ0E7Ozs7b0JDREE7TUFBQTt1Q0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/physical-cards/physical-cards/physical-cards.component.ngfactory.ts